import { FlagIcon as FlagIconSolid } from '@heroicons/react/24/solid';
import { FlagIcon as FlagIconOutline } from '@heroicons/react/24/outline';

interface ResultFlagProps {
  isKeyResult: boolean;
  className?: string;
}

/**
 * ResultFlag — decorative flag icon for Result vs Key Result distinction.
 *
 * Semantics:
 *   solid (filled) = Key Result (milestone for a deliverable)
 *   outline (hollow) = Result (inchstone to mark progress)
 *
 * Both variants always render — no conditional hiding. Use `isKeyResult`
 * to select the correct variant. The icon is aria-hidden (decorative);
 * accessible meaning is carried by surrounding label text.
 *
 * INV-FLAG-1: solid flag is rendered when isKeyResult is true
 * INV-FLAG-2: outline flag is rendered when isKeyResult is false
 * INV-FLAG-3: all rendered flag icons have aria-hidden="true"
 */
export function ResultFlag({ isKeyResult, className = 'h-4 w-4 text-blue-600 flex-shrink-0' }: ResultFlagProps) {
  if (isKeyResult) {
    return <FlagIconSolid className={className} aria-hidden="true" />;
  }
  return <FlagIconOutline className={className} aria-hidden="true" />;
}
